import axios from 'axios';

let apiUrl = process.env.VUE_APP_API_URL;

export default {
  listSmartQuoteAttachments: (payload) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/attachments`,
      params: payload,
    });
  },
  getSmartQuoteAttachment: (id) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/attachment/${id}`,
    });
  },
  getSmartQuoteStats: () => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/stats`,
    });
  },
  processSmartQuoteMailbox: () => {
    return axios({
      method: 'post',
      url: `${apiUrl}/admin/smart-quote/process-mailbox`,
    });
  },
  processSmartQuoteAttachment: (id) => {
    return axios({
      method: 'post',
      url: `${apiUrl}/admin/smart-quote/process-attachment`,
      data: {id},
    });
  },
  fetchSmartQuotePdf: (id) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/attachment/${id}/pdf`,
      responseType: 'blob',
    });
  },
  fetchSmartQuoteAuditTrail: (id) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/attachment/${id}/audit`,
    });
  },
  getSmartQuoteProposalMap: () => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/proposal-map`,
    });
  },
  getSmartQuoteProposalAudit: (proposalId) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/proposal/${proposalId}/audit`,
    });
  },
  createSmartQuoteProposal: (id, payload) => {
    return axios({
      method: 'post',
      url: `${apiUrl}/admin/smart-quote/attachment/${id}/create-proposal`,
      data: payload || {},
    });
  },
  dismissSmartQuoteAttachment: (id) => {
    return axios({
      method: 'post',
      url: `${apiUrl}/admin/smart-quote/attachment/${id}/dismiss`,
    });
  },
  rememberSmartQuoteSender: (id, payload) => {
    return axios({
      method: 'post',
      url: `${apiUrl}/admin/smart-quote/attachment/${id}/remember-sender`,
      data: payload || {},
    });
  },
  getCompanySmartQuoteSenders: (companyId) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/company/${companyId}/smart-quote-senders`,
    });
  },
  createCompanySmartQuoteSender: (companyId, payload) => {
    return axios({
      method: 'post',
      url: `${apiUrl}/admin/company/${companyId}/smart-quote-senders`,
      data: payload,
    });
  },
  updateSmartQuoteSender: (id, payload) => {
    return axios({
      method: 'patch',
      url: `${apiUrl}/admin/smart-quote-senders/${id}`,
      data: payload,
    });
  },
  deleteSmartQuoteSender: (id) => {
    return axios({
      method: 'delete',
      url: `${apiUrl}/admin/smart-quote-senders/${id}`,
    });
  },
  getSmartQuoteCompanyCarriers: (attachmentId, companyId) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/smart-quote/attachment/${attachmentId}/company-carriers`,
      params: {company_id: companyId},
    });
  },
  getCompanySmartQuoteSettings: (companyId) => {
    return axios({
      method: 'get',
      url: `${apiUrl}/admin/company/${companyId}/smart-quote-settings`,
    });
  },
  updateCompanySmartQuoteSettings: (companyId, payload) => {
    return axios({
      method: 'put',
      url: `${apiUrl}/admin/company/${companyId}/smart-quote-settings`,
      data: payload,
    });
  },
};
